module.exports = __webpack_public_path__ + "static/media/header_1024.b3481e89.mp4";